export const getEventLabel = (labelMenu: string, showTagNewFeature: boolean) =>
  `${labelMenu.toLowerCase().split(' ').join('-')}${showTagNewFeature ? ':novidade' : ''}`;
